import type { FieldError } from 'react-hook-form';

/**
 * react-hook-form types a leaf error as `FieldError`, but an error on an OBJECT / RECORD / UNION
 * field (an account `allocation`, a stream `growthMode`, a `TimePoint`) is a
 * `Merge<FieldError, FieldErrorsImpl<…>>` whose `type` is optional — so it is NOT assignable to the
 * plain `FieldError` the shared `<Field>` primitive expects. Our nested editors accept this broader
 * shape and normalise it to a `<Field>`-ready `FieldError` (we only ever render `.message`).
 */

/** Anything react-hook-form might hand us for a non-leaf field — we only read `message`. */
export type AnyFieldError = { message?: string | undefined } | undefined;

/** Normalise an RHF error (leaf or merged) into the plain `FieldError` the `<Field>` UI renders. */
export function toFieldError(error: AnyFieldError): FieldError | undefined {
  if (error === undefined) return undefined;
  const message = error.message;
  if (typeof message !== 'string' || message.length === 0) return undefined;
  return { type: 'validate', message };
}
